import React from 'react';
import { Route, IndexRoute } from 'react-router';
import URLHelpers from '../components/shared/url_helpers';

const ConvertShopTypeRoute = (
  <Route
    key={URLHelpers.convertShopTypePath}
    path={URLHelpers.convertShopTypePath}
    getComponent={(_location, cb) => {
      import(
        /* webpackChunkName: 'onboarding' */
        '../onboarding/legacy/convert_shop_type_container'
      ).then(m => cb(null, m.default));
    }}
  >
    <IndexRoute
      getComponent={(_location, cb) => {
        import(
          /* webpackChunkName: 'onboarding' */
          '../onboarding/legacy/convert_shop_type_form'
        ).then(m => cb(null, m.default));
      }}
    />
    <Route
      key={URLHelpers.convertShopTypeFinishPath}
      path={URLHelpers.convertShopTypeFinishPath}
      getComponent={(_location, cb) => {
        import(
          /* webpackChunkName: 'onboarding' */
          '../onboarding/legacy/convert_shop_type_complete'
        ).then(m => cb(null, m.default));
      }}
    />
  </Route>
);

export default ConvertShopTypeRoute;
